// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.table[data-v-5d060508] {\n  margin-bottom: 0;\n}\n[data-v-5d060508] .empty-list {\n  margin-bottom: 0;\n}\n\n", ""]);
// Exports
module.exports = exports;
